<template>
  <div
    :class="[
      'BaseInput',
      { 'valid':   !invalid },
      { 'invalid': invalid },
      { 'dirty':   dirty },
      { 'empty':   !value },
      { 'hasIcon': icon },
      { 'hasClearText': showClearText },
      { noBorder },
    ]">

    <div
      v-if="icon"
      class="_icon"
      key="BaseInput-Icon-leading">
      <i
        :class="'icon-' + icon">
      </i>
    </div>
    <input
      class="_input"
      ref="input"
      :style="computedInputStyle"
      :value="value"
      :type="type"
      :placeholder="placeholder"
      :required="required"
      :disabled="disabled"
      :autofocus="autofocus"
      :autocomplete="autocomplete"
      @input="$emit('input', $event.target.value)"
      @keydown="$emit('keydown', $event)"
      @focus="$emit('focus')"
      @blur="$emit('blur', $event)"
    />
    <button
      v-if="showClearText && value.length"
      class="BaseInput_ClearTextBtn"
      type="button"
      @click="$emit('input', '')">
    </button>
  </div>
</template>

<script>
export default {
  name: 'BaseInput',

  props: {
    value:         { type: [String, Number], default: null },
    height:        { type: Number,  default: 32 },
    noBorder:      { type: Boolean, default: false },
    focused:       { type: Boolean, default: false },
    dirty:         { type: Boolean, default: false },
    invalid:       { type: Boolean, default: false },
    type:          { type: String,  default: 'text' },
    placeholder:   { type: String,  default: 'Type something...' },
    icon:          { type: String,  default: null },
    iconColor:     { type: String,  default: 'mute' },
    required:      { type: Boolean, default: false },
    disabled:      { type: Boolean, default: false },
    autofocus:     { type: Boolean, default: false },
    autocomplete:  { type: String,  default: 'off' },
    showClearText: { type: Boolean, default: false },
  },

  computed: {
    computedInputStyle() {
      return {
        height: `${this.height}px`,
      };
    },
  },

  watch: {
    focused(val) { if (val) this.$refs.input.focus(); },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

.BaseInput {
  position: relative;
  text-align: left;
}

.BaseInput ._input {
  display: block;
  width: 100%;
  height: 32px;
  padding-left: 12px;
  padding-right: 12px;
  font-size: 14px;
  border: $border;
  border-radius: $radius;
  background: $white;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  transition: border .3s ease 0s;
  &::-ms-clear {
    display: none;
  }
}

.BaseInput.noBorder ._input {
  border: none;
}

.BaseInput.hasIcon ._input {
  padding-left: 34px;
}

.BaseInput.hasClearText ._input {
  padding-right: 34px;
}

.BaseInput ._icon {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 6px;
  width: 24px;
  height: 24px;
  margin: auto;
  font-size: 16px;
  text-align: center;
  opacity: .6;
}

.BaseInput.dirty.invalid ._input {
  border-color: $red;
}

.BaseInput_ClearTextBtn {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 6px;
  width: 24px;
  height: 24px;
  margin: auto;
  background-image: url('https://web-assets.domo.com/miyagi/images/icon/domo-icon/domo-icon-delete-remove-exit-close-dark.svg');
  background-size: 12px;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 50%;
  opacity: .6;
  &:hover {
    opacity: 1;
    background-color: rgba($black, .05);
  }
}
</style>
